import Vue from "vue";
import MultipleBox from "@/components/MultipleBox";

Vue.use(MultipleBox);
